import {
  InfoText,
  PaddingContainer
} from "../../views/tasks/update-application/style";
import Accordion from "../Accordion/Accordion";
import {
  AmountCell,
  HeaderAmount,
  HeaderRow,
  LeaBankBadge,
  Row,
  Rows,
  SummaryBar,
  TypeBadge
} from "./styles";
import type { Debt, DebtListProps, DebtRowProps } from "./types";

const formatAmount = (value?: number): string => {
  if (value === undefined || value === null || Number.isNaN(value)) {
    return "-";
  }
  try {
    return new Intl.NumberFormat(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  } catch {
    return String(value);
  }
};

const DebtRow: React.FC<DebtRowProps> = ({ debt, idx }) => {
  return (
    <Row $isEven={idx % 2 === 0}>
      <div>
        <TypeBadge $type={debt.type}>{debt.type}</TypeBadge>
      </div>
      <div>
        <InfoText>
          {debt.description}
          {debt.isLeaBankDebt && <LeaBankBadge>Lea Bank</LeaBankBadge>}
        </InfoText>
      </div>
      <AmountCell>
        <InfoText>{formatAmount(debt.amount)}</InfoText>
      </AmountCell>
    </Row>
  );
};

export const DebtList: React.FC<DebtListProps> = ({
  debts,
  title = "Debts from UC"
}: DebtListProps) => {
  // Filter out invalid debts
  debts = debts.filter(
    (debt: Debt) =>
      debt.amount !== undefined &&
      debt.amount !== null &&
      !Number.isNaN(debt.amount) &&
      debt.type !== undefined &&
      debt.type !== null &&
      debt.description !== undefined &&
      debt.description !== null
  );
  return (
    <Accordion title={title} hasChevron={true}>
      <PaddingContainer>
        {/* Summary */}
        <SummaryBar>
          <span>
            {debts.length} {debts.length === 1 ? "debt" : "debts"}
          </span>
          <span>
            Total:{" "}
            {formatAmount(
              debts.reduce(
                (sum: number, d: Debt) => sum + (Number(d.amount) || 0),
                0
              )
            )}
          </span>
        </SummaryBar>
        {/* Header */}
        <HeaderRow>
          <div>Type</div>
          <div>Description</div>
          <HeaderAmount>Amount</HeaderAmount>
        </HeaderRow>

        {/* Rows */}
        <Rows>
          {debts
            .slice()
            .sort(
              (a: Debt, b: Debt) =>
                a.type.localeCompare(b.type) ||
                (Number(b.amount) || 0) - (Number(a.amount) || 0)
            )
            .map((debt: Debt, idx: number) => {
              const key = `${debt.type}-${debt.description}-${debt.amount}-${idx}`;
              return <DebtRow key={key} debt={debt} idx={idx} />;
            })}
        </Rows>
      </PaddingContainer>
    </Accordion>
  );
};
